import * as React from 'react'

function ExhibitorsLegalLaw(props) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.5 20.5v-.406A2.1 2.1 0 0115.594 18h3.312A2.1 2.1 0 0121 20.094v.406a.5.5 0 01-.5.5H14a.5.5 0 01-.5-.5zM15.25 13.492a2 2 0 114.001.016 2 2 0 01-4.001-.016v0zM3 19a2 2 0 002 2M3 16v3M9 21H5M3 19a2 2 0 002 2M3 16v3M9 21H5M3 19a2 2 0 002 2M3 16v3M10 21H5M3 12v-.406A2.1 2.1 0 015.094 9.5h3.312a2.1 2.1 0 012.094 2.094V12a.5.5 0 01-.5.5H3.5A.5.5 0 013 12zM4.75 4.992a2 2 0 114 .016 2 2 0 01-4-.016zM21 5.031a2 2 0 00-2-2M21 9V5.031M12 3.031h7"
        stroke="#1F2D27"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export { ExhibitorsLegalLaw }
